import * as React from "react";

function CanadaFlag() {
  return (
    <svg
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_494_7453)">
        <path
          d="M23.9606 15.9868H0.420381C0.188238 15.9868 0 15.7985 0 15.5664V0.433396C0 0.201254 0.188238 0.0130157 0.420381 0.0130157H23.9606C24.1928 0.0130157 24.381 0.201254 24.381 0.433396V15.5664C24.381 15.7986 24.1927 15.9868 23.9606 15.9868Z"
          fill="#F5F5F5"
        />
        <path
          d="M18.9161 0.0133667H5.46472V15.9872H18.9161V0.0133667Z"
          fill="#F5F5F5"
        />
        <path
          d="M0.420381 0.0130615C0.188238 0.0130615 0 0.201252 0 0.433395V15.5664C0 15.7985 0.188238 15.9868 0.420381 15.9868H5.46471V0.0130615H0.420381Z"
          fill="#FF4B55"
        />
        <path
          d="M23.9603 0.0130615H18.916V15.9868H23.9603C24.1925 15.9868 24.3807 15.7985 24.3807 15.5664V0.433395C24.3807 0.201252 24.1925 0.0130615 23.9603 0.0130615Z"
          fill="#FF4B55"
        />
        <path
          d="M14.7414 9.84594L17.2358 8.4206L16.6634 8.13442C16.5029 8.05413 16.411 7.8808 16.4348 7.70284L16.621 6.30656L15.565 6.6138C15.3317 6.6817 15.0896 6.53818 15.0371 6.30099L14.936 5.84385L13.9444 7.00432C13.8069 7.16518 13.5451 7.04232 13.5809 6.83375L14.0044 4.37147L13.3561 4.5488C13.1667 4.60061 12.9667 4.51442 12.8743 4.34118L12.1916 3.06161V3.05971L12.1912 3.06066L12.1906 3.05971V3.06161L11.5079 4.34118C11.4155 4.51437 11.2155 4.60056 11.0261 4.5488L10.3777 4.37147L10.8012 6.83375C10.8371 7.04223 10.5752 7.16513 10.4377 7.00432L9.4461 5.84385L9.34496 6.30099C9.29248 6.53823 9.05039 6.68165 8.8171 6.6138L7.76105 6.30656L7.94729 7.70284C7.97105 7.88075 7.87915 8.05413 7.71862 8.13442L7.14624 8.4206L9.64067 9.84598C9.89905 9.99365 10.0123 10.3068 9.90805 10.5855L9.69482 11.1558L11.8322 10.9734C11.9505 10.9633 12.0512 11.0585 12.0477 11.1771L11.9803 13.4649H12.4007L12.3333 11.177C12.3299 11.0584 12.4305 10.9632 12.5488 10.9733L14.6872 11.1558L14.474 10.5855C14.3698 10.3067 14.483 9.99355 14.7414 9.84594Z"
          fill="#FF4B55"
        />
      </g>
      <defs>
        <clipPath id="clip0_494_7453">
          <rect width="24.381" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CanadaFlag;
